import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { doc, setDoc } from 'firebase/firestore';
import { saveOrgInfoLocal } from 'src/app/globals';
import { db, auth, dataStore, dataStoreSignal } from 'src/app/app.component';

@Component({
  selector: 'app-set-organisation',
  templateUrl: './set-organisation.component.html',
  styleUrls: ['./set-organisation.component.scss'],
})
export class SetOrganisationComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    // to set organisation use: /set/wemaron
    const orgId = this.route.snapshot.paramMap.get('orgId');
    if (orgId) {
      await saveOrgInfoLocal(orgId);
      if (dataStore?.rootUser) {
        const org = dataStore.rootUser.organisations.find((x) => x.id === orgId);
        if (org) {
          await setDoc(
            doc(db, `users/${dataStore.rootUser.id}`),
            {
              selectedOrgId: orgId,
            },
            { merge: true },
          );
          dataStore.selectedOrganisation = org;
          dataStore.orgUser = null;
          dataStore.publicSettings = null;
          if (dataStore.subscribes.length > 0) {
            dataStore.subscribes.forEach((subscriber) => subscriber.unsub());
            dataStore.subscribes = [];
          }
          dataStoreSignal.set({ ...dataStore });
          this.router.navigate(['/profile']).then(() => {
            location.reload();
          });
        } else {
          if (dataStore.subscribes.length > 0) {
            dataStore.subscribes.forEach((subscriber) => subscriber.unsub());
            dataStore.subscribes = [];
          }
          await auth.signOut();
          return this.router.navigate(['/auth']);
        }
      } else {
        this.router.navigate(['/auth']);
      }
    }
  }
}
